import './email-recipients-display.scss';

import EmailRecipientsDisplay from './EmailRecipientsDisplay';

export default EmailRecipientsDisplay;
